import { createFileRoute } from '@tanstack/react-router';

import Box from '@mui/material/Box';

import { OrgSectionPicker } from 'src/components/settings/OrgSectionPicker';
import { ClientManagement } from 'src/components/settings/ClientManagement';

// ----------------------------------------------------------------------

export const Route = createFileRoute('/_authed/dashboard/o/$orgId/settings/organization/clients')({
  component: OrganizationClientsPage,
});

function OrganizationClientsPage() {
  return (
    <Box>
      <OrgSectionPicker />
      <Box sx={{ mt: 3 }}>
        <ClientManagement />
      </Box>
    </Box>
  );
}
